import { CSS } from '@grupoboticario/flora-react'

export const sectionTitleCss: CSS = {
  marginBottom: '$4'
}

export const addButtonRowCss: CSS = {
  borderTop: '1px dashed rgba(0, 0, 0, 0.24)',
  padding: '$2'
}

export const addButtonCss: CSS = {
  marginTop: '$4'
}
